import { useQuery } from '@tanstack/react-query';
import { LanguageService } from '../services/language';
import { ILanguageCode } from '../interfaces/languageCode';
import { IBaseUseQueryProps } from '../interfaces/baseUseQueryProps';
import { parseAxiosError } from '../services/axios';
import { useNotification } from '../+state/useNotification';

export const GET_LANGUAGE_CODES_QUERY_KEY = 'get-language-codes';

export const useGetLanguageCodes = (props?: IBaseUseQueryProps<ILanguageCode[]>) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [GET_LANGUAGE_CODES_QUERY_KEY],
    queryFn: () => LanguageService.getCodes(),
    staleTime: Number.MAX_SAFE_INTEGER,
    onError: (err) => {
      openErrorToast(parseAxiosError(err));
      props?.onError?.(err);
    },
    ...props
  });
};